export module config {
	export const apiServer = "https://apis.jibunu.com/jump/";
	export const topBarBackgroundColor = "white";
	export const logLevel = "debug";
	export const localStoreName = "jibToken";
	export const agentDebug = false;
	export const strict = true;
	export const toastrOpts = {
		"closeButton": false,
		"debug": false,
		"newestOnTop": false,
		"progressBar": false,
		"positionClass": "toast-top-center",
		"preventDuplicates": false,
		"onclick": null,
		"showDuration": "300",
		"hideDuration": "300",
		"timeOut": "1000",
		"extendedTimeOut": "1000",
		"showEasing": "linear",
		"hideEasing": "linear",
		"showMethod": "slideDown",
		"hideMethod": "slideUp"
	};

	export const templatePermissions = {
		"1": [
			{
				"name": "report viewer",
				"id": "SyxnHlIStG",
				"fullAccess": true,
				"excludedActions": ["Respondent Duration By Page"]
			},
			{
				"name": "respondent manager",
				"id": "HJlPKPDVtf",
				"fullAccess": true
			},
			{
				"name": "quota editor",
				"id": "Hyg2ydPVYf",
				"fullAccess": true
			},
			{
				"name": "project details",
				"id": "SJge-wPNtf",
				"fullAccess": false,
				"actions": ["full-view"]
			},
			{
				"name": "data files",
				"id": "Skx_HDv4tf",
				"fullAccess": true
			},
			{
				"name": "qa tool",
				"id": "cm7HvkS5Ka",
				"fullAccess": true
			}
		],
		"2": [
			{
				"name": "report viewer",
				"id": "SyxnHlIStG",
				"fullAccess": false,
				"actions": ["Simple Counter", "Vendor Report"]
			},
			{
				"name": "project details",
				"id": "SJge-wPNtf",
				"fullAccess": false,
				"actions": []
			}
		],
		"3": [
			{
				"name": "respondent manager",
				"id": "HJlPKPDVtf",
				"fullAccess": true
			},
			{
				"name": "project details",
				"id": "SJge-wPNtf",
				"fullAccess": false,
				"actions": ["full-view"]
			},
			{
				"name": "qa tool",
				"id": "cm7HvkS5Ka",
				"fullAccess": true
			}
		]
	};
}



// WEBPACK FOOTER //
// ./src/config.ts